'use client';
import type { ContextModalProps } from '@mantine/modals';
import NoteContent from './note-content';
export type NoteModalProps = ContextModalProps<{
  initialValue?: string;
}>;
export default function NoteModal({ context }: NoteModalProps) {
  const onClose = () => {
    context.closeAll();
  };
  return (
    <>
      <NoteContent onClose={onClose} />
    </>
  );
}
